import { render, staticRenderFns } from "./Male.vue?vue&type=template&id=3b7db30d&"
import script from "./Male.vue?vue&type=script&lang=js&"
export * from "./Male.vue?vue&type=script&lang=js&"
import style0 from "./Male.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports